export default {
  // Wage by minute
  wageByMinute: [],
  // Additional wage
  additionalWage: [],
  // Service tariff history
  serviceTariffHistory: [],
  serviceTariffHistoryCount: 0,
}
